import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { __stringify, addItemToArrayAtIndex, Filter, MimeType_json, Second, sortArray } from '@nu-art/ts-common';
import { _className, Button, EventType_Create, EventType_Delete, EventType_DeleteMulti, EventType_Query, EventType_UpsertAll, getElementCenterPos, LL_H_C, LL_V_C, LL_V_L, MenuBuilder, ModuleFE_MouseInteractivity, ModuleFE_Thunderstorm, mouseInteractivity_PopUp, openContent, ProtoComponent, SimpleListAdapter, stopPropagation, ToastBuilder, TS_VirtualizedList } from '@nu-art/thunderstorm-frontend/index';
import './Panel_Variables.scss';
import { VariableWrapper } from '../../../../wrappers/index.js';
import { QToastContent } from '../../../q-components/index.js';
import { Dialog_VariableEditor } from '../Dialogs/index.js';
import { Panel_Header } from '../../../shared-components/index.js';
import { ICONS } from '@app/styles';
import { ModuleFE_Referencable, ModuleFE_Tag, ModuleFE_Variable, } from '../../../../_entity.js';
import { DBDef_Tag, DBDef_Variable, valueType_Range, variableType_EvidenceOf, variableType_FamilyHistoryOf, variableType_HistoryOf, variableType_Normal, variableType_Recent } from '@app/hcs-shared/core';
import { PermissionsComponent } from '@nu-art/permissions-frontend/index';
import { ModuleFE_HCSPermissions } from '../../../../permissions/index.js';
import { CreateDiscussionPopup } from '../../../messaging/CreateDiscussionPopup/CreateDiscussionPopup.js';
import { AccessLevel, ModuleFE_PermissionsAssert } from '@nu-art/permissions-frontend/modules/ModuleFE_PermissionsAssert';
import { ModuleFE_CollectionActions } from '@nu-art/thunderstorm-frontend/modules/ModuleFE_CollectionActions';
import { ModuleFE_ConflictResolution } from '@nu-art/conflict-resolution-frontend/_modules/ModuleFE_ConflictResolution';
import { Dialog_ReferencableEditor } from '../../../../_entity/referencable/Dialog_ReferencableEditor/Dialog_ReferencableEditor.js';
import { Tooltip_VariableInformation } from '../Tooltip_VariableInformation/index.js';
export class Panel_Variables extends ProtoComponent {
    //######################### Static #########################
    static defaultProps = {
        keys: ['selected', 'filterVariables'],
    };
    //######################### Life Cycle #########################
    __onVariableUpdated(...params) {
        switch (params[0]) {
            case EventType_Query:
            case EventType_UpsertAll:
            case EventType_Create:
                this.onVariableSelected(Array.isArray(params[1]) ? params[1][0] : params[1]);
                this.reDeriveState();
                break;
            case EventType_Delete:
            case EventType_DeleteMulti:
                this.onVariableSelected();
                this.reDeriveState();
                break;
            // case EventType_Update:
            // 	this.reDeriveState({selectedVariable: undefined});
            // 	return;
        }
    }
    deriveStateFromProps(nextProps, state) {
        const selected = { ...this.getQueryParam('selected', {}) };
        const selectedTagId = selected[DBDef_Tag.dbKey];
        const selectedVariableId = selected[DBDef_Variable.dbKey];
        const selectedVariable = ModuleFE_Variable.cache.unique(selectedVariableId);
        const filter = this.getQueryParam('filterVariables');
        //Define variables
        if (!selectedTagId) {
            state.variables = [];
            return state;
        }
        const variables = ModuleFE_Variable.cache.filter(variable => variable._tagIds.includes(selectedTagId));
        state.variables = sortArray(variables, variable => variable._nameInLowercase);
        //No selected variable
        if (!selectedVariableId || !selectedVariable) {
            if (selectedVariableId && !selectedVariable)
                this.logError('Missing Variable', `tried to get a variable for id ${selectedVariableId} but it wasn't in the cache`, state.variables.length ? `Setting new selected variable id ${state.variables[0]._id}` : 'Clearing selected variable id from URL params');
            let shouldSetQueryParam = true;
            if (state.variables.length)
                selected[DBDef_Variable.dbKey] = state.variables[0]._id;
            else {
                if (!selected[DBDef_Variable.dbKey])
                    shouldSetQueryParam = false;
                delete selected[DBDef_Variable.dbKey];
            }
            if (shouldSetQueryParam)
                this.setQueryParam('selected', selected);
            //returning state here. next derive run should continue with the new data
            return state;
        }
        //Filter variables
        if (filter && filter.length >= 3) {
            const _filter = new Filter(variable => new VariableWrapper(variable).getSearchableText());
            state.variables = _filter.filterSort(state.variables, filter);
        }
        //If the selected variable did not pass the filter
        if (selectedVariable && state.variables.findIndex(variable => variable._id === selectedVariable._id) === -1) {
            addItemToArrayAtIndex(state.variables, selectedVariable, 0);
        }
        return state;
    }
    //######################### Logic #########################
    onVariableSelected = (selectedVariable) => {
        const selected = { ...this.getQueryParam('selected', {}) };
        if (!selectedVariable)
            delete selected[DBDef_Variable.dbKey];
        else
            selected[DBDef_Variable.dbKey] = selectedVariable._id;
        this.setQueryParam('selected', selected);
    };
    openHeaderMenu = (e) => {
        stopPropagation(e);
        const menuItems = [
            {
                label: 'Add Variable',
                onClick: () => {
                    const selectedTagId = this.getQueryParam('selected', {})[DBDef_Tag.dbKey];
                    if (!selectedTagId) {
                        new ToastBuilder().setDuration(3 * Second)
                            .setContent(QToastContent({
                            iconKey: 'infoToast',
                            content: 'Please select a category first!',
                            toastType: 'info'
                        }))
                            .show();
                        return;
                    }
                    Dialog_VariableEditor.show(selectedTagId);
                }
            },
            {
                label: 'Export Variables',
                onClick: () => {
                    const patientData = {
                        fileName: `hsc-variables`,
                        content: __stringify(this.state.variables.reduce((toRet, v) => {
                            toRet[v.name] = v._id;
                            return toRet;
                        }, {}), true),
                        charset: 'UTF-8',
                        mimeType: MimeType_json
                    };
                    return ModuleFE_Thunderstorm.downloadFile(patientData);
                }
            }
        ];
        const adapter = SimpleListAdapter(menuItems, renderer => _jsx("div", { className: 'node-data', children: renderer.item.label }));
        const modalId = 'panel-variables__right-click-menu';
        const pos = getElementCenterPos(e.currentTarget);
        new MenuBuilder(adapter, pos, { x: 0, y: 1 })
            .setId(modalId)
            .setOffset({ x: 0, y: 10 })
            .setOnClick((path, item) => {
            ModuleFE_MouseInteractivity.hide(mouseInteractivity_PopUp);
            item.onClick?.();
        })
            .show();
    };
    createChildVariable = async (parent, childType) => {
        if (![variableType_HistoryOf, variableType_FamilyHistoryOf, variableType_EvidenceOf, variableType_Recent].includes(childType))
            return;
        const response = await ModuleFE_Variable._v1.createChild({ parentVarId: parent._id, targetType: childType }).executeSync();
        const selected = this.getQueryParam('selected', {});
        const selectedTagId = selected[DBDef_Tag.dbKey];
        Dialog_VariableEditor.show(selectedTagId, response.child);
    };
    getRightClickOptions = (variable) => {
        const options = [
            {
                label: 'Check Usage',
                closePopUpOnFinish: true,
                action: async (e) => {
                    const response = await ModuleFE_CollectionActions.check.usage({
                        dbKey: DBDef_Variable.dbKey,
                        itemIds: [variable._id]
                    }).executeSync();
                    if (response.dependencies)
                        ModuleFE_ConflictResolution.showDependencies(response.dependencies);
                }
            },
            {
                label: 'Edit Referencable',
                closePopUpOnFinish: true,
                action: () => {
                    const referencable = ModuleFE_Referencable.cache.find(referencable => !!referencable.dbRefs?.find(ref => ref.id === variable._id));
                    if (!referencable)
                        return Dialog_ReferencableEditor.show({ context: { dbKey: DBDef_Variable.dbKey, id: variable._id } });
                    Dialog_ReferencableEditor.show({ referencableId: referencable._id });
                }
            },
            {
                label: 'Create Discussion',
                closePopUpOnFinish: false,
                action: (e) => {
                    const discussionView = {
                        id: 'discussion-right-click-menu',
                        originPos: { y: e.clientY, x: e.clientX },
                        modalPos: { x: 0, y: 1 },
                        content: _jsx(CreateDiscussionPopup, { entityName: ModuleFE_Variable.dbDef.entityName, refId: variable._id }),
                    };
                    ModuleFE_MouseInteractivity.showContent(discussionView);
                }
            },
        ];
        if (variable.type !== variableType_Normal)
            return options;
        //Add options to create children
        [variableType_HistoryOf, variableType_FamilyHistoryOf, variableType_EvidenceOf, variableType_Recent].forEach(type => {
            const existingChild = ModuleFE_Variable.cache.find(child => child.type === type && child.parentId === variable._id);
            if (existingChild)
                return;
            options.push({
                label: `Create "${type}" child`,
                closePopUpOnFinish: true,
                action: () => this.createChildVariable(variable, type),
            });
        });
        return options;
    };
    onContextMenu = (e, variable) => {
        const options = this.getRightClickOptions(variable);
        const model = {
            id: 'variable-right-click-menu',
            originPos: { y: e.clientY, x: e.clientX },
            modalPos: { x: 1, y: 1 },
            content: () => _jsx(_Fragment, { children: options.map((option, i) => {
                    return _jsx(Button, { onClick: async (e) => {
                            await option.action(e);
                            if (option.closePopUpOnFinish)
                                ModuleFE_MouseInteractivity.hide(mouseInteractivity_PopUp);
                        }, children: option.label }, i);
                }) })
        };
        ModuleFE_MouseInteractivity.showContent(model);
    };
    //######################### Render #########################
    renderHeader() {
        const selectedTagId = this.getQueryParam('selected', {})[DBDef_Tag.dbKey];
        const selectedTag = ModuleFE_Tag.cache.unique(selectedTagId);
        const filter = this.getQueryParam('filterVariables');
        const canAccess = ModuleFE_PermissionsAssert.getAccessLevel(ModuleFE_HCSPermissions.permissions.collection.edit);
        return _jsx(Panel_Header, { config: { filter }, onFilterChanged: (filter) => {
                this.setQueryParam('filterVariables', filter);
            }, qsearchId: 'panel-variable-search', headerClassName: 'panel__variables__header', title: { label: selectedTag?.label || 'Variables', className: 'panel__variables__header__title' }, headerTail: canAccess === AccessLevel.HasAccess ? _jsx("div", { className: 'panel__variables__header__icon', children: _jsx(ICONS.more.component, { onClick: e => {
                        return this.openHeaderMenu(e);
                    } }) }) : undefined });
    }
    renderList() {
        if (!this.state.variables.length)
            return this.renderMessage('No variables to show');
        const selected = this.getQueryParam('selected', {});
        const selectedTagId = selected[DBDef_Tag.dbKey];
        const selectedVariableId = selected[DBDef_Variable.dbKey];
        return (_jsx("div", { className: 'list-wrapper', children: _jsx(TS_VirtualizedList, { itemHeight: 50, className: 'variable-list custom-scrollbar__vertical', listToRender: this.state.variables.map((variable, i) => {
                    const uiVariableObject = new VariableWrapper(variable);
                    const value = uiVariableObject?.getValue();
                    let measurementUnitString;
                    if (value?.type === valueType_Range)
                        measurementUnitString = value.data.measurementUnit?.unitAsString;
                    const className = _className('var-item', variable._id === selectedVariableId ? 'selected' : undefined);
                    return _jsxs(LL_H_C, { className: className, style: { justifyContent: 'space-between' }, onClick: () => this.onVariableSelected(variable), onContextMenu: (e) => this.onContextMenu(e, variable), children: [_jsxs(LL_V_L, { className: _className('var-name'), children: [`${variable.name}${measurementUnitString ? ` (${measurementUnitString})` : ''}`, _jsx("span", { className: 'filter-pass-reason', children: uiVariableObject.renderVarFilterPassReason(variable.name) })] }), _jsxs(LL_H_C, { className: _className('var-item-tail'), children: [_jsx(PermissionsComponent, { permissionKey: ModuleFE_HCSPermissions.permissions.collection.edit, children: _jsx("div", { className: 'edit-button', onClick: (e) => {
                                                stopPropagation(e);
                                                Dialog_VariableEditor.show(selectedTagId, variable);
                                            }, children: _jsx(ICONS.edit.component, {}) }) }), _jsx("div", { className: 'variable-info-tooltip-icon', ...openContent.tooltip.right('variable-info-tooltip', () => _jsx(Tooltip_VariableInformation, { variable: variable }), {
                                            overlayClass: 'transparent',
                                            contentHoverDelay: 200,
                                            offset: 10
                                        }), children: "i" })] })] }, `${variable._id}-${i}`);
                }) }) }));
    }
    renderMessage(message) {
        return _jsx(LL_V_L, { className: 'match_width', style: { justifyContent: 'center', alignItems: 'center', flex: 1 }, children: message });
    }
    render() {
        return _jsxs(LL_V_C, { className: 'panel__variables', children: [this.renderHeader(), this.renderList()] });
    }
}
//# sourceMappingURL=Panel_Variables.js.map